import React from "react";

// The mark scheme, checked against what the student actually wrote: a tick for each
// creditable point they earned, a dash for each they did not.
//
// This belongs inside the explanation, not the verdict card. The verdict says what THIS
// answer did; opening the explanation is the student asking to see the full answer, and
// this is the itemised half of it — which points exist, and which ones they got. Shown
// unasked in the verdict it is just the answer key, handed over before they want it.

const TONE = {
  light: {
    heading: "text-slate-400",
    met: "bg-emerald-500 text-white",
    unmet: "bg-slate-300 text-white",
    metText: "text-slate-700",
    unmetText: "text-slate-500",
    rule: "border-slate-200",
  },
  dark: {
    heading: "text-white/40",
    met: "bg-emerald-500 text-white",
    unmet: "bg-white/15 text-white/70",
    metText: "text-white/85",
    unmetText: "text-white/45",
    rule: "border-white/10",
  },
};

const CheckIcon = () => (
  <svg viewBox="0 0 20 20" className="h-3.5 w-3.5 shrink-0" fill="currentColor" aria-hidden="true">
    <path
      fillRule="evenodd"
      d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 111.4-1.4l3.8 3.8 6.8-6.8a1 1 0 011.4 0z"
      clipRule="evenodd"
    />
  </svg>
);

const DashIcon = () => (
  <svg viewBox="0 0 20 20" className="h-3.5 w-3.5 shrink-0" fill="currentColor" aria-hidden="true">
    <path fillRule="evenodd" d="M4 10a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1z" clipRule="evenodd" />
  </svg>
);

const ProbabilisticCriteriaList = ({ criteria, theme = "light" }) => {
  if (!criteria?.length) return null;

  const tone = TONE[theme] ?? TONE.light;

  return (
    <div className={`mt-3 border-t pt-3 ${tone.rule}`}>
      <p className={`text-[11px] font-semibold uppercase tracking-wider ${tone.heading}`}>
        Marking points
      </p>

      <ul className="mt-2 space-y-1.5">
        {criteria.map((criterion, i) => (
          <li key={i} className="flex items-start gap-2 text-xs leading-relaxed">
            <span
              className={`mt-0.5 flex h-4 w-4 items-center justify-center rounded-full ${
                criterion.met ? tone.met : tone.unmet
              }`}
            >
              {criterion.met ? <CheckIcon /> : <DashIcon />}
            </span>
            <span className={criterion.met ? tone.metText : tone.unmetText}>
              {criterion.description}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProbabilisticCriteriaList;
